import { render } from "./ArticleExtension.vue?vue&type=template&id=2639516b"
import script from "./ArticleExtension.vue?vue&type=script&lang=js"
export * from "./ArticleExtension.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__